import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { IFastFiltersUserResponseSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserResponseSchema';
import {
  fetchGetUserDataByRequest,
  IGetUserDataByRequestResponse200,
  IGetUserDataByRequestResponse400,
} from '../../repositories/monolith-python/v1/get-user-data-by-request';
import { assertUnknownError } from './assert';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: string;
}

export async function resolveUser({
  httpApi,
  logger,
  subdomain,
}: IDependencies): Promise<IFastFiltersUserResponseSchema> {
  try {
    const result = await fetchGetUserDataByRequest<IGetUserDataByRequestResponse200, IGetUserDataByRequestResponse400>({
      httpApi,
      parameters: {},
      config: {
        subdomain,
      },
    });

    assertUnknownError(result);

    return result.response.data;
  } catch (error) {
    logger.error(error, {
      comment: '[Degradation] Нет информации о пользователе, пользователь считается неавторизованным',
    });

    return {};
  }
}
